import { useNavigate } from 'react-router-dom';
import { useAlerts } from '../../../api/alerts';
import type { AlertSeverity } from '../../../types';

const SEVERITY_BADGES: Record<AlertSeverity, { bg: string; text: string }> = {
  critical: { bg: 'bg-red-500/20', text: 'text-red-400' },
  high: { bg: 'bg-orange-500/20', text: 'text-orange-400' },
  medium: { bg: 'bg-amber-500/20', text: 'text-amber-400' },
  low: { bg: 'bg-blue-500/20', text: 'text-blue-400' },
  info: { bg: 'bg-cyan-500/20', text: 'text-cyan-400' },
};

export default function AlertListWidget() {
  const navigate = useNavigate();
  const { data: alertsData } = useAlerts({
    page: 1,
    page_size: 10,
    sort_by: 'created_at',
    sort_order: 'desc',
  });

  const alerts = alertsData?.items ?? [];

  return (
    <div className="glass-panel p-4 h-full flex flex-col">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-300">Alertes recentes</h3>
        <button
          onClick={() => navigate('/alerts')}
          className="text-xs text-cyber-cyan hover:underline"
        >
          Tout voir
        </button>
      </div>
      <div className="flex-1 overflow-y-auto space-y-1.5">
        {alerts.length > 0 ? (
          alerts.map((alert) => {
            const badge = SEVERITY_BADGES[alert.severity] ?? SEVERITY_BADGES.info;
            return (
              <div
                key={alert.id}
                onClick={() => navigate(`/alerts?selected=${alert.id}`)}
                className="flex items-center gap-2.5 p-2.5 rounded-lg border border-border-subtle cursor-pointer hover:bg-surface-tertiary/50 transition-colors"
              >
                <span
                  className={`flex-shrink-0 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${badge.bg} ${badge.text}`}
                >
                  {alert.severity}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-gray-200 truncate">{alert.title}</p>
                </div>
                <span className="text-[10px] text-gray-500 whitespace-nowrap flex-shrink-0">
                  {new Date(alert.created_at).toLocaleTimeString('fr-FR', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </span>
              </div>
            );
          })
        ) : (
          <p className="text-sm text-gray-500 text-center py-8">Aucune alerte</p>
        )}
      </div>
    </div>
  );
}
